import { Adapter as r } from "../../../../adapter.js";
import { CheckoutDesignColorsModel as n } from "./colors.model.js";
class c extends r {
  adapt(e) {
    return new n({
      background: e.general_background ?? "#ffffff",
      text: e.general_text ?? "#242323",
      lines: e.general_lines ?? "#eeeeee",
      highlightBackground: e.main_section_background ?? "#eff8fb",
      highlightText: e.main_section_text ?? "#006080",
      highlightLines: e.main_section_lines ?? "#a3d8e9",
      primaryButtonBackground: e.main_button_background ?? "#fca2f3",
      primaryButtonText: e.main_button_text ?? "#242323",
      secondaryButtonBackground: e.secondary_button_background ?? "#e3e3e3",
      secondaryButtonText: e.secondary_button_text ?? "#242323",
      errorBackground: e.error_background ?? "#eb565c",
      errorText: e.error_text ?? "#ffffff"
    });
  }
  serialize(e) {
  }
}
export {
  c as CheckoutDesignColorsAdapter
};
//# sourceMappingURL=colors.adapter.js.map
